import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { Flex, Box } from 'shared/ui'
import { isForwarding } from 'util/draft'
import { getValueByPath } from 'util/objects'

import ToRow from '../ToRow'
import CcRow from '../CcRow'
import BccRow from '../BccRow'
import FromRow from '../FromRow'
import SubjectRow from '../SubjectRow'

const Expanded = ({
  bccVisible,
  ccVisible,
  children, // i.e. FormSwitcherButton
  className,
  closeTo,
  draft,
  draftType,
  focusField,
  fromVisible,
  onActionClick,
  onMailboxClick,
  onSubjectChange,
  onSubjectEnter,
  recipients,
  recipientsOpenUpward,
  subjectVisible,
  ticketId,
}) => {
  // if we provide a children prop, its assumed its a FormSwitcherButton, so we
  // indent all subsequent rows by 52px
  const indent = children ? 40 : undefined
  const startInEditMode =
    (isForwarding(draftType) && !getValueByPath('to[0].id', recipients)) ||
    focusField === 'to'

  return (
    <Flex flexDirection="column" className={className}>
      <ToRow
        bccVisible={bccVisible}
        ccVisible={ccVisible}
        closeTo={closeTo}
        fromVisible={fromVisible}
        isForwarding={isForwarding(draftType)}
        onActionClick={onActionClick}
        subjectVisible={subjectVisible}
        ticketId={ticketId}
        recipients={recipients.to}
        recipientsOpenUpward={recipientsOpenUpward}
        startInEditMode={startInEditMode}
        key={ticketId}
      >
        {children}
      </ToRow>

      {ccVisible && (
        <Box ml={indent}>
          <CcRow
            recipients={recipients.cc}
            startInEditMode={focusField === 'cc'}
            ticketId={ticketId}
            recipientsOpenUpward={recipientsOpenUpward}
          />
        </Box>
      )}

      {bccVisible && (
        <Box ml={indent}>
          <BccRow
            recipients={recipients.bcc}
            startInEditMode={focusField === 'bcc'}
            ticketId={ticketId}
            recipientsOpenUpward={recipientsOpenUpward}
          />
        </Box>
      )}

      {fromVisible && (
        <Box ml={indent}>
          <FromRow draft={draft} onMailboxClick={onMailboxClick} />
        </Box>
      )}

      {subjectVisible && (
        <Box ml={indent}>
          <SubjectRow
            draft={draft}
            onChange={onSubjectChange}
            onEnter={onSubjectEnter}
            startInEditMode={focusField === 'subject'}
          />
        </Box>
      )}
    </Flex>
  )
}

Expanded.propTypes = {
  draft: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  closeTo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  recipientsOpenUpward: PropTypes.bool,
}

Expanded.defaultProps = {
  closeTo: undefined,
  recipientsOpenUpward: false,
}

export default styled(Expanded)`
  width: 100%;
`
